import { idGenerator } from '@/utils/generator'
import type { Answer as AnswerType } from '@/types/answer.type'
import Media from './media.model'

export default class Answer implements AnswerType {
  _id = idGenerator()
  id = 1
  ans = ''
  correct = false
  ansMedia = new Media()
  constructor(ans?: string) {
    if (ans) {
      this.ans = ans
    }
  }
}
